module.exports = __webpack_public_path__ + "img/taiyuan-f9adc7.png";